/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
export const handleBlurToScrollableAccordion = (task?: string) => {
    const accordions = document.querySelectorAll("dl dd") as any;

    for (const accordion of accordions) {
        if (accordion && accordion.scrollHeight > accordion.clientHeight) {
            const scrollHandler = () => {
                const scrollAmount = accordion.scrollHeight - Math.ceil(accordion.scrollTop);

                if (scrollAmount <= accordion.clientHeight + 3 && scrollAmount >= accordion.clientHeight - 3) {
                    accordion.classList.remove("scrollable");

                    return;
                }

                if (!accordion.classList.contains("scrollable")) {
                    accordion.classList.add("scrollable");
                }
            };

            if (task === "remove") {
                accordion.removeEventListener("scroll", scrollHandler);
                return;
            }

            accordion.classList.add("scrollable");
            accordion.addEventListener("scroll", scrollHandler);
        }
    }
};

export default handleBlurToScrollableAccordion;
